var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-info-item links"},[_c('InfoItemTitle',{attrs:{"title":_vm.title}}),_vm._l((_vm.links),function(link,index){return _c('div',{key:index},[_c('app-link',{attrs:{"href":link.href}},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.SOURCE_LINK,"text":link.href}}),_vm._v(" "+_vm._s(link.text)+" ")],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }